var map = {
	"./Inter-VariableFont_opsz,wght.ttf": 50839,
	"./NotoSansJP-VariableFont_wght.ttf": 8855,
	"./YuGothic-Bold-01.ttf": 27418,
	"./YuGothic-Medium-01.ttf": 48858,
	"./YuGothic-Regular-01.ttf": 92231,
	"fonts/Inter-VariableFont_opsz,wght.ttf": 50839,
	"fonts/NotoSansJP-VariableFont_wght.ttf": 8855,
	"fonts/YuGothic-Bold-01.ttf": 27418,
	"fonts/YuGothic-Medium-01.ttf": 48858,
	"fonts/YuGothic-Regular-01.ttf": 92231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6065;